import { render, staticRenderFns } from "./NotPublishedIndicator.vue?vue&type=template&id=a44f03a4&scoped=true&"
import script from "./NotPublishedIndicator.vue?vue&type=script&lang=ts&"
export * from "./NotPublishedIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./NotPublishedIndicator.vue?vue&type=style&index=0&id=a44f03a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44f03a4",
  null
  
)

export default component.exports